import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import TranslateIcon from '@mui/icons-material/Translate';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import MicIcon from '@mui/icons-material/Mic';

import CropFreeIcon from '@mui/icons-material/CropFree';
import LayersIcon from '@mui/icons-material/Layers';
import AddchartIcon from '@mui/icons-material/Addchart';

import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import TextIncreaseIcon from '@mui/icons-material/TextIncrease';

export const editorLangEnStrs = {

    /** Updated at 01.12.2025 */
    //Hero component
    chip_label: "New: Powerful AI Video Editing Suite",
    main_headline_part_1: "Your All-in-One ",
    main_headline_part_2: "Cloud Video",
    main_headline_part_3: "Workspace.",
    main_headline_part_4: "Edit Anything. Anywhere.",
    main_subtitles: "Advanced AI video creation in your browser: convert horizontal to vertical, auto-edit scenes, track faces, and preserve speaker identity with next-gen AI dubbing.",
    feature_cards: [
        {
            icon: <AutoAwesomeIcon fontSize="large" sx={{ color: '#00BCD4' }}/>,
            title: "AI Viral Generator",
            description: "Create face-tracked viral shorts from long videos in seconds."
          },
          {
            icon: <MicIcon fontSize="large" sx={{ color: '#9C27B0' }}/>,
            title: "Voice Cloning Dubbing",
            description: "Dub in 40+ languages while keeping original vocal identity."
          },
          {
            icon: <TranslateIcon fontSize="large" sx={{ color: '#2196F3' }}/>,
            title: "Auto-Subs & Translate",
            description: "99% accurate captions and instant translation."
          },
          {
            icon: <AddAPhotoIcon fontSize="large" sx={{ color: '#E91E63' }}/>,
            title: "Generative AI Suite",
            description: "Integrated Text-to-Speech & AI Image Generation."
          }
    ],
    start_editing_button: "Start Editing →",
    ai_dubbing_button: "Try AI Dubbing (Beta)",
    workspace_preview: "Video Workspace Preview",
    //Discover
    discover_ai_shorts_features: [
        {
          icon: <CropFreeIcon fontSize="large" sx={{ color: '#00BCD4' }}/>,
          title: "AI Face Tracking",
          description: "Intelligent reframing keeps the speaker perfectly centered in 9:16 vertical format."
        },
        {
          icon: <LayersIcon fontSize="large" sx={{ color: '#9C27B0' }}/>,
          title: "Batch Generation",
          description: "Upload one 60-minute video and get 40+ fully edited, captioned shorts instantly."
        },
        {
          icon: <AddchartIcon fontSize="large" sx={{ color: '#2196F3' }} />,
          title: "Virality Score",
          description: "Our AI ranks clips based on potential engagement so you post only the best."
        }
    ],
    discory_label: "AI-agent as Assistant Director",
    discovery_left_headline_1: "One Landscape Video.",
    discovery_left_headline_2: "40+ Viral Shorts.",
    disocry_left_headline_3: "Don't let your podcast or YouTube content collect dust. Kedy.ai automatically identifies viral hooks, reframes the active speaker, and generates engaging vertical clips in minutes.",
    discovery_CTA_button: "Turn 1 Video into 10 Shorts Now →",
    discovery_video_mockups_1: "ORIGINAL SERIES",
    discovery_video_mockups_2: "The Tech Revolution",
    discovery_video_mockups_3: "S4 • E2",
    discovery_video_mockups_4: "THIS IS INSANE! 🤯",

    // Other tools
    other_tools_features: [
        {
          icon: <MicIcon fontSize="large" sx={{ color: '#9C27B0' }}/>,
          title: "True Voice Cloning",
          description: "We analyze your unique vocal print to create a dubbed version that sounds exactly like you."
        },
        {
          icon: <ChatBubbleIcon fontSize="large" sx={{ color: '#E91E63' }}/>,
          title: "Perfect Lip Sync (Beta)",
          description: "The video is subtly adjusted to match the lip movements of the new language for a natural look."
        },
        {
          icon: <TextIncreaseIcon fontSize="large" sx={{ color: '#2196F3' }}/>,
          title: "Contextual Translation",
          description: "Slang, idioms, and technical terms are translated accurately to maintain the original meaning."
        }
    ],

    other_tools_right_side_label:"🎙️ GLOBAL VOICE STUDIO",
    other_tools_headline:"Go Global.",
    speak_local:"Speak Local.",
    ai_dubbing_explanation: "Break language barriers without losing your identity. Our AI Dubbing engine translates your content into 40+ languages while preserving your original voice, emotion, and intonation.",
    other_tools_CTA_button: "Clone My Voice & Dub",
    global_reach_badge_1: "Voice Cloning",
    global_reach_badge_2: "98% Match Accuracy",
    global_reach_badge_3: "Global Reach",
    global_reach_badge_4: "40+ Languages Supported",

    // Social
    social_left_menu_badge: "SEAMLESS INTEGRATION",
    social_left_menu_title_1: "Connect Your Entire",
    social_left_menu_title_2: "Creative Ecosystem.",
    social_left_menu_explanation: "Don't waste time downloading and re-uploading. Kedy.ai connects directly to your favorite platforms for one-click publishing and asset synchronization.",
    social_features: [
      {
        title: "Smart Scheduling",
        desc: "Plan ahead. Select specific dates and times for your content to go live.",
        color: '#22d3ee' // Cyan
      },
      {
        title: "Direct Video Upload",
        desc: "Upload 4K footage directly from your device to the cloud editor.",
        color: '#a78bfa' // Purple
      },
      {
        title: "Secure API Management",
        desc: "Enterprise-grade encryption for all your connected accounts.",
        color: '#34d399' // Green
      }
    ],
    social_right_menu_title: "API Keys & Connections",

    // Carousel
    loved_by_creators_1: "Loved by",
    loved_by_creators_2: "Creators",
    loved_by_creators_3: "Automating workflows for the best in the game.",
    carousel_button_1: "Get Started for Free",
    carousel_button_2: "Book a Demo",



    /** Updated at 01.12.2025 */
    
    welcomNewProject: 'Welcome to your new project',
    pls_add_media: 'Please add media to your project',
    add_video: 'Add Video',
    add_audio: 'Add Audio',
    add_image: 'Add Image',
    add_webcam: 'WebCam Capture',
    add_screen: 'Screen Capture',
    screen_and_cam_recorder: 'WebCam & Screen Capture',
    capture_screen_camera: 'Capture your screen & camera !',
    video_captureDevice: 'Video Capture Device',
    resolution: 'Resolution',
    audio_captureDevice: 'Audio Capture Device',
    resize_video: 'Resize Video',
    rotate_video: 'Rotate Video',
    loop_video: 'Loop Video',
    joinmarge_video: 'Add Join/Merge Video',
    cut_video: 'Cut Video',
    crop_video: 'Crop Video',
    integrations:'Integrations',
    custom_privacy_and_security:'Custom Privacy and Security',
    translate_video: 'Translate Video',
    transcripbe_video: 'Transcribe Video',
    auto_subtitles: 'Auto Subtitles',
    add_subtitle_video: 'Add Subtitle to Video',
    video_compressor: 'Compress Video',
    video_compressor_basic: 'UP TO 1 GB',
    video_compressor_pro:'UP to 5 GB',
    video_compressor_max:'Unlimited',
    video_compressor_premium:'Unlimited',
    convert_video_basic:'Up to 1 GB',
    convert_video_pro:'Up to 5 GB',
    convert_video_max:'Unlimited',
    convert_video_premium:'Unlimited',
    convert_video: 'Convert Video',
    project_not_accessible: 'Project is not accessible',
    continue: 'Continue',
    leave: 'Leave',
    cancel: 'Cancel',
    submit: 'Submit',
    okay: 'Ok',
    stop: 'Stop',
    record: 'Record',
    ongoing_upload_project_str: 'There is an ongoing upload to this project.',
    leaving_page_sure: 'You are leaving this page, are you sure?',
    uploading_files: 'Uploading Files',
    record_screen_and_upload: 'Record your screen and upload.',
    show_defaul_sharingMenu: 'Show default sharing MenuItems',
    prefer_share_browser: 'Prefer to share a browser tab',
    prefer_share_window: 'Prefer to share a window',
    prefer_share_entireScreen: 'Prefer to share an entire screen',
    record_webcam_and_upload: 'Record your web camera and upload.',
    sign_signup_to_uploadVideos: 'Please sign in or sign up to upload videos',
    sizelimir_or_timelimit: 'larger than 250 Mbytes or longer than 5 minutes',
    screen_capture_preferences: 'Screen Capture Preferences',
    is_uploading: 'Is Uploading',
    monthly: 'Monthly',
    annually: 'Annually',
    most_popular: 'Most Popular',
    export: 'Export',
    bitrate: 'Bitrate',
    frame_rate_fps: 'Frame Rate (FPS)',
    produce: 'Produce',
    setup: 'Setup',
    template: 'Template',
    templates: 'Templates',
    subtitles: 'Subtitles',
    media: 'Media',
    corporate_add_ons:'Corporate add Ons',
    workflow_tools: 'Workflow Tools',
    stock: 'Stock',
    translations: 'Translations',
    subtitle_translation: 'Subtitle Translation',
    text_to_speech: 'Text To Speech',
    transitions: 'Transitions',
    text: 'Text',
    emojis: 'Emojis',
    filters: 'Filters',
    draw: 'Draw',
    edit_subtitle: 'Edit Subtitle',
    add_new_subtitle: 'add new subtitle',
    select_brush_stock_start_draw: 'Select a brush stroke to start drawing',
    brush_stroke: 'Brush Stroke',
    round: 'Round',
    sliced: 'Sliced',
    color: 'Color',
    opacity: 'Opacity',
    size: 'Size',
    duration: 'Duration',
    add_new_line: 'Add New Line',
    all_types: 'All Types',
    load_more: 'Load More',
    upload_video: 'Upload Video',
    upload_audio: 'Upload Audio',
    upload_image: 'Upload Image',
    create_webcam_recording: 'Create Webcam Recording',
    create_screen_capture_recording: 'Create Screen Capture Recording',
    create_webcam_screen_recording: 'Create Webcam & Screen Recording',
    project_asset: 'Project Asset',
    you_want_add_translations: 'How do you want to add translations?',
    uploader: 'Uploader',
    auto: 'AUTO',
    auto_translations: 'Auto Translations',
    automatically_add_transllations_video: 'Automatically add translations to video',
    wait_moments_subtitles_being: 'Wait for a few moments while subtitle is being prepared',
    select_language_detect: 'Select language to detect',
    select_different_target_language: 'Select different target language',
    select_different_source_and_target_languages: 'Source and target languages cannot be equal',
    voice_clones: "Voice Clones",
    source_language: "Source Language",
    select_source_language: "Select Source Language",
    select_target_language: "Select Target Language",
    redub_another_language: 'Re-Dub with Another Language',
    upload_new_file: 'Upload New File',
    dubbing_enabled_info_text: "Enable Dubbing",
    dubbing_disabled_hint_text: "Dubbing is currently disabled for your organization. Contact your administrator for more information.",
    no_title: 'No Title',
    unknown: 'Unknown',
    watch_video: 'Watch Video',
    listen_audio: 'Listen Audio',
    video_preparing: 'Video Preparing',
    audio_preparing: 'Audio Preparing',
    delete_voice_clone: 'Delete Voice  Clone',
    delete_voice_clone_assets: 'Delete Voice Clone with Assets',
    no_voice_clones: 'No voice clones to display',
    upload_file_to_create_first_voice_clone: 'Upload a file to create your very first Voice Clone and sweep the language barrier away',
    disable_translate: 'Disable Translate',
    select_language_select: 'Select Language to translate into',
    transition_duration: 'Transition Duration',
    coming_soon: 'Coming Soon',
    language: 'Language',
    english: "English",
    spanish: "Spanish",
    french: "French",
    german: "German",
    italian: "Italian",
    portuguese: "Portuguese",
    polish: "Polish",
    turkish: "Turkish",
    russian: "Russian",
    dutch: "Dutch",
    czech: "Czech",
    arabic: "Arabic",
    chinese: "Chinese",
    hungarian: "Hungarian",
    korean: "Korean",
    japanese: "Japanese",
    hindi: "Hindi",
    danish: "Danish",
    greek: "Greek",
    finnish: "Finnish",
    hebrew: "Hebrew",
    malay: "Malay",
    norwegian: "Norwegian",
    swedish: "Swedish",
    swahili: "Swahili",
    speaking_rate_defaul: 'Speaking Rate (default 1)',
    pitch_defaul: 'Pitch (default 0)',
    volume_gain_default: 'Volume Gain (default 0)',
    create_text_speech: 'Create Text To Speech',
    add_text: 'Add Text',
    video_player:'Video Player',
    audio_noise_removal:'Audio removal',
    share_and_embed: 'Share and Embed',
    private_workspaces: 'Private Workspaces',
    text: 'Text',
    custom_templates: 'Custom Template',
    start: 'Start',
    end: 'End',
    text_style: 'Text Style',
    background_color: 'Background Colour',
    add_new_text_field: 'Add New Text Field',
    how_add_subtitles: 'How do you want to add subtitles',
    automatically_subtitles_video: 'Automatically add subtitles to video',
    text_color: 'Text Colour',
    preview_text: 'Preview Text',
    search: 'Search',
    orientation: 'Orientation',
    next: 'Next',
    previous: 'Previous',
    first: "First",
    last: "Last",
    locale: 'Locale',
    landscape: 'Landscape',
    portrait: 'Portrait',
    square: 'Square',
    time: 'Time',
    background: 'Background',
    project_setting: 'Project Settings',
    use_template_project: 'Use as template project',
    visibility: 'Visibility',
    category: 'Category',
    capture_thumbnail: 'Capture Thumbnail',
    brand_kit: 'Brand Kit',
    video_placeholder: 'Video Placeholder2.mp4',
    replace_video: 'Replace Video',
    transformations: 'Transformations',
    fill_canvas: 'Fill the canvas',
    fit_canvas: 'Fit the canvas',
    round_corners: 'Round Corners',
    audio: 'Audio',
    detach_audio: 'Detach Audio',
    cleanAudio: 'CleanAudio',
    upgrade_basic_unlock: 'Upgrade to BASIC to unlock',
    remove_background_noise_enhance_audio_qty: 'Remove background noise and enhance audio quality',
    color_correction: 'Color Correction',
    reset: 'Reset',
    exposure: 'Exposure',
    brightness: 'Brightness',
    contract: 'Contrast',
    saturation: 'Saturation',
    sharpen: 'Sharpen',
    blur: 'Blur',
    noise: 'Noise',
    trending: 'TRENDING',
    custom: 'CUSTOM',
    portrait: 'PORTRAIT',
    landscape: 'LANDSCAPE',
    settings: 'Settings',
    magic_draw: 'Magic Draw',
    tools: 'Tools',
    brush_size: 'Brush Size',
    save: 'Save',
    clear: 'Clear',
    view_all: 'View All',
    save_your_project_later: 'Save your project for later',
    sign_in: 'sign in',
    sign_up: 'sign up',
    sign_up_home: 'Signup',
    redo: 'REDO',
    undo: 'UNDO',
    collaborate: 'COLLABORATE',
    enter_email_share_project: 'Enter email to share project',
    share_project: 'Share Project',
    create_new_workspace: 'Create new Workspace',
    audio_noise_remove: 'Audio Noise Removal',
    media_upload: 'Media Upload',
    draw_color: 'Draw Color',
    tsl_none: 'none',
    tsl_fade: 'Fade',
    tsl_book_flip: 'Book Flip',
    tsl_disolve: 'Disolve',
    tsl_doorway: 'Doorway',
    tsl_blur: 'Blur',
    tsl_push: 'Push',
    tsl_slide: 'Slide',
    tsl_wipe: 'Wipe',
    tsl_zoom_in: 'Zoom In',
    tsl_zoom_out: 'Zoom Out',
    flt_None: 'None',
    flt_Darker: 'Darker',
    flt_BlacknWhite: 'BlacknWhite',
    flt_Daphne: 'Daphne',
    flt_Penelope: 'Penelope',
    flt_Phoebe: 'Phoebe',
    flt_Thalia: 'Thalia',
    flt_Chloe: 'Chloe',
    flt_Hermione: 'Hermione',
    flt_Hera: 'Hera',
    flt_Rhea: 'Rhea',
    flt_Donna: 'Donna',
    flt_Martina: 'Martina',
    flt_Gabriella: 'Gabriella',
    flt_Elisabetta: 'Elisabetta',
    flt_Isabella: 'Isabella',
    flt_Luna: 'Luna',
    flt_Viola: 'Viola',
    flt_Zita: 'Zita',
    flt_Donata: 'Donata',
    flt_Maddalena: 'Maddalena',
    flt_Tecla: 'Tecla',
    flt_Narcisa: 'Narcisa',
    emj_Smileys: 'Smileys',
    emj_Animals: 'Animals',
    emj_People: 'People',
    emj_Jobs: 'Jobs',
    emj_Sports: 'Sports',
    emj_Flags: 'Flags',
    emj_Signs: 'Signs',
    emj_Nature: 'Nature',
    emj_Travel: 'Travel',
    emj_Letters: 'Letters',
    emj_Misc: 'Misc',
    create_empty_project_templates: 'Create an Empty Project From Templates',
    days_ago: 'days ago',
    hours_ago: 'hours ago',
    minutes_ago: 'minutes ago',
    seconds_ago: 'seconds ago',
    create_workspace: 'Create Workspace',
    workspace: 'Workspaces',
    delete_workspace: 'Delete Workspace',
    transfer_owner: 'Transfer Owner',
    can_create_new_workspace: 'Could you create new workspace?',
    could_delete_workspace: 'Could you delete workspace?',
    available_subtitles_time: 'Available Subtitles Time',
    available_storage_space: 'Available Storage Space',
    available_text_to_speech: 'Available Text To Speech',
    other_workspaces: 'Other workspaces',
    members: 'Members',
    add_member: 'Add Member',
    remove_member: 'Remove Member',
    change_member_level: 'Change Member Level',
    owner: 'Owner',
    admin: 'Admin',
    member: 'Member',
    read_only: 'Read Only',
    duplicate: 'Duplicate',
    splite: 'Split',
    remove: 'remove',
    layer: 'Layer',
    volume: 'Volume',
    disable: 'Disable',
    deleterow: 'DeleteRow',
    fullscreen: 'Fullscreen',
    editsubtitle: 'EditSubtitle',
    fit: 'Fit',
    green_screen: 'Green Screen',
    profile: 'Profile',
    contact_us: 'Contact Us',
    pricing: 'Pricing',
    pricing_compare_header: 'Compare Plans',
    pricing_all_plans_description: 'All plans include all video editing features, auto subtitles, unlimited projects, and unlimited rendering',
    pricing_apply_coupon: 'Apply Coupon',
    pricing_faq_header: 'Frequently Asked Questions',
    faq_question_1: 'Do you provide subscription options for educational institutions?',
    login: 'Login',
    logout: 'Log out',
    get_started_free: "Get Started-it's free",
    dashboard: 'Dashboard',
    projects: 'Projects',
    menu_Features: 'Features',
    menu_Tools: 'Tools',
    menu_Convert: 'Video Converter',
    menu_Compressor: 'Video Compressor',
    menu_AIVideoEditor: 'Video Editor',
    menu_VideoEditor: 'Video Editor',
    menu_AddImgToVideo: 'Add Image To Video',
    menu_AddMusicToVideo: 'Add Music To Video',
    menu_AddTextToVideo: 'Add Text To Video',
    menu_FilterVideo: 'Filter Video',
    menu_AddTransitionstoVideo: 'Add Transitions to Video',
    menu_AddFreeStockVideos: 'Add Free Stock Videos',
    menu_SubtitlesTranscription: 'Subtitles & Transcription',
    menu_AddSubtitlesToVideo: 'Add Subtitles To Video',
    menu_AudioToText: 'Audio To Text',
    menu_AutoSubtitles: 'Auto Subtitles',
    menu_TranscribeVideo: 'Transcribe Video',
    menu_TranslateVideo: 'Translate Video',
    menu_Toolkit: 'Toolkit',
    menu_Crop: 'Crop',
    menu_Cut: 'Cut',
    menu_JoinMerge: 'Join / Merge',
    menu_LoopVideo: 'Loop Video',
    menu_Resize: 'Resize',
    menu_Rotate: 'Rotate',
    menu_More: 'More',
    menu_VideoCompressor: 'Video Compressor',
    menu_VideoConverter: 'Video Converter',
    menu_AIGenerated: 'AI-Generated',
    menu_AIVideoSummary: 'AI Video Summarization',
    menu_AIGeneratedImages: 'AI-Generated Images',
    menu_AIGeneratedVideos: 'AI-Generated Videos',
    menu_AIGeneratedVoices: 'AI-Generated Voices',
    menu_Blog: 'Blog',
    support: 'Support',
    menu_VIDEOOBlog: 'Kedy.AI Blog',
    menu_VIDEOOHowTo: 'Kedy.AI How to',
    menu_VIDEOOCareers: 'Kedy.AI Careers',
    the_basics: "The Basics",
    no_watermark: "No Watermark",
    tip_no_watermark: "Whether your video is watermark free",
    try_autosubtitles_in_english: 'Try Auto Subtitles in English',
    try_translations_in_turkish: 'Try Translations in Turkish',
    try_subtitles_in_spanish: 'Try Subtitles in Spanish',
    try_ai_video_summary: 'Try AI Video Summary',
    online_ai_video_editor: 'AI Video Editor',
    online_could_video_editor: 'Online Cloud Based Video Editor',
    home_free_trial_detail: '7 Days Free Trial, Cancel Anytime',
    home_create_button_detail: 'One-click video creation with automated subtitles, translation',
    create_now: 'Create New Video',
    home_templates_start: 'Explore a range of templates to get started',
    try_now_required: 'Try it now, no account required',
    online_collaborative_video_editing: 'Online Collaborative Video Editing',
    online_collaborative_video_editing_detail: 'Dive into the world of Online Cloud-Based Video Editing with kedy.ai. Our platform revolutionizes the way you edit, offering Online Collaborative Video Editing capabilities and a Cloud-Based Video Editing Workspace.',
    auto_subtitles_translations: 'Auto Subtitles and Translations',
    auto_subtitles_translations_detail: "Enhance your videos with our Auto Subtitles and Translations feature, a part of our Professional Online Video Editing Software. Designed to be a Video Editing Software Tool for Everyone, kedy.ai makes it simple to create content that's accessible and catchy.",
    ai_base_text_speech: 'AI based Text To Speech',
    ai_base_text_speech_detail: 'Our AI-based Text to Speech Voices are perfect for content creators, embodying the concept of Video Editing Reinvented for Youtubers and Influencers. With kedy.ai, transform your scripts into engaging voiceovers, adding a professional touch to your videos and streamlining your production process.',
    free_user_stock_video: 'Free to use Stock Videos',
    free_user_stock_video_detail: 'Access a vast collection of Free to Use Stock Videos with kedy.ai, complementing our 4K Video Editing Online capabilities. Our platform, being a 4K Video Editing Software for Everyone, ensures that your projects stand out with high-quality footage, making professional-grade editing accessible to all users.',
    share: 'Share',
    unlisted_video: 'Unlisted Video',
    your_video_about_ready: 'Your video is about to be ready',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    want_free_stuff: 'Want some free stuff?',
    record_screen_webcam_both: 'Record your screen, webcam, or both',
    add_subtitle_your_video: 'Add subtitles to your videos',
    create_your_team_workspace: 'Create your Team Workspace',
    collaborate_videos: 'Collaborate on videos',
    generate_transcript: 'Generate a transcript',
    singup_get_all_this_more: 'Sign up (for free) to get all this and more!',
    downloading: 'Downloading',
    download: 'Download',
    reedit_video: 'Re-edit video',
    remove_watermark: 'Remove watermark',
    already_have_account: 'Already have an account?',
    link_copied: 'Link Copied',
    invitation_list: 'Invitation List',
    remove_invitation: 'Remove Invitation',
    change_workspace: ' Change workspace',
    you_login_manage_your_profile: 'You need to login to manage your profile',
    you_dont_have_content_here: "You don't have any content here.",
    name: 'Name',
    status: 'Status',
    data_modified: 'Date Modified',
    all_workspaces: 'All Workspaces',
    delete_project: 'Delete Project',
    duplicate_project: 'Duplicate Project',
    draft: 'Draft',
    edit: 'Edit',
    surname: 'Surname',
    email: 'Email',
    plan: 'Plan',
    market_emails: 'Marketing Emails',
    editor_notification: 'Editor Notifications',
    storage: 'Storage',
    subtitle: 'Subtitle',
    delete_account: 'Delete Account',
    this_action_irreversibe: 'This action is irreversible',
    current_plan: 'CURRENT PLAN',
    cancel_subscription: 'Cancel Subscription',
    payment_method: 'PAYMENT METHODS',
    expires: 'Expires',
    make_default: 'Make Default',
    delete: 'Delete',
    add_payment_method: 'Add payment method',
    billing_information: 'BILLING INFORMATION',
    invoice_history: 'INVOICE HISTORY',
    payment: 'Payment',
    preferences: 'Preferences',
    save_up_to: 'Save Up To ',
    your_plan: 'Your Plan',
    inactive: 'Inactive',
    contact_sales: 'Contact Sales',
    need_additional_features: 'Need additional features? Ask us about our Enterprise plan',
    //new homepage strings
    your_online: 'Your Online',
    ai_video_editor: 'AI Video Editor',
    upload_file_size: 'Upload File Size',
    upload_file_size_tip: 'The maximum file size that you can upload',
    upload_file_size_unlimited: 'Upload file size – unlimited',
    export_quality_1080p: 'Export Quality – 1080p',
    one_click_post_production: 'Clip,Reframe,Caption',
    while_pet_your_cat:'While You Pet Your Cat / Sip Your Coffee', 
    try_for_free: 'Try for Free',
    video_export_length: 'Video Export Length',
    video_export_length_tip: 'The maximum video length you can export',
    video_export_length_free: '10 mins',
    video_export_length_basic: '25 mins',
    video_export_length_pro: '2 hours',
    video_export_length_business: '2 hours',
    your_online_ai_video_editor: 'AI Video Editor',
    discover_kedy: 'Discover AI-Powered Tools of Kedy.AI!',
    create_video_summaries: 'Create AI-Powered Video Summaries',
    video_summary_description: 'Kedy.AI’s creates key sections from long videos with titles, descriptions, and easy downloads—fast and effortless.',
    ai_video_dubbing: 'Remove The Language Barrier with AI Voice Dubbing',
    ai_shorts_reels_generator: 'AI Shorts/Reels Generator',
    select_options_to_create_shorts: 'Select options to create AI-Powered Shorts/Reels videos.',
    select_ai_shorts_options: 'Select AI Shorts Options',
    summarize_your_content_in: 'Summarize your content in . . .',
    set_silence_threshold: 'Set the silence threshold (in seconds):',
    more_chapters: 'More Chapters',
    less_chapters: 'Less Chapters',
    set_min_clip_duration: 'Set the minimum clip duration (in seconds):',
    set_num_of_chapters: 'Set the number of total chapters:',
    ai_video_dubbing_description: 'Kedy.AI’s dubbing tool lets you speak any language—while keeping your own voice. Just upload a video, and AI handles the rest effortlessly.',
    viral_clips: 'Create Viral Clips with AI Viral Generator to Share on Social Media',
    viral_clips_description: 'Turn any video into eye-catching viral clips with Kedy.AI’s magic—smart face focus, highlighted subtitles, and ready-to-share content for social media success!',
    kedy_ai_editor: 'Kedy.AI’s Editor Has Everything for Your Needs',
    kedy_offers_essential_video_editor_tools: 'Kedy.AI Offers All Essential Tools of A Video Editor',
    create_project: 'Create Project',
    other_ai_tools: 'Other Modern AI-Powered Tools',
    ai_generated_subtitles: 'AI-Generated Auto Subtitles',
    ai_translation: 'AI-Translation',
    ai_text_to_speech: 'Text-To-Speech',
    ai_generated_images: 'AI-Generated Images',
    finish_post_production: 'Finish your post-production work with just a few clicks!',
    try_now: 'Try Now',
};